import { createContext, useContext, useState } from 'react';

import { ThemeProvider } from '@myphx-engineering/phx-design-system/framework';
import type theme from '@myphx-engineering/phx-theme';

import { brandConstants } from '../theme/brand-constants';

export type BrandProviderCtx = {
    theme: typeof theme;
    logoPath: string;
    brandId: string;
    setBrand: (brand: string) => void;
};

export const defaultBrandId = 'Prescryptive';

export const BrandContext = createContext<BrandProviderCtx>({
    brandId: defaultBrandId,
    theme: brandConstants[defaultBrandId].theme,
    logoPath: brandConstants[defaultBrandId].logoPath,
    setBrand: () => {
        /* Default no-op function*/
    },
});

export const BrandProvider = ({ children }: { children: React.ReactNode }) => {
    // react router's useSearchParams is not available in this context
    const searchParams = window.location.search
        ? new URLSearchParams(window.location.search)
        : new URLSearchParams();
    const [brand, setBrand] = useState(
        searchParams.get('brandId') ?? defaultBrandId
    );

    const brandValues = brandConstants[brand] ?? brandConstants[defaultBrandId];

    return (
        <BrandContext.Provider
            value={{ ...brandValues, brandId: brand, setBrand }}
        >
            <ThemeProvider theme={brandValues.theme}>{children}</ThemeProvider>
        </BrandContext.Provider>
    );
};

export const useBrandContext = () => {
    const context = useContext(BrandContext);
    if (!context) {
        throw new Error('useBrandContext must be used within a BrandProvider');
    }
    return context;
};
